module.exports = __webpack_public_path__ + "static/img/5.1da38ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/sp/5.png
// module id = hZSc
// module chunks = 0